import {useEffect, useState} from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import { Drawer,  useMediaQuery } from '@mui/material';
import ImageButton from '../ImageButton';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import {  setCurrentUser } from '../../applicationSlice';
import {logout} from '../../firebase';
const logo = process.env.REACT_APP_LOGO_URL;


export default function Nav() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const application = useSelector(state=>state.application);
  const wallet = useSelector(state=>state.wallet);

  const [role,setRole]=useState('user');
  const [signedIn,setSignedIn]=useState(false);
  const isMobile = useMediaQuery('(max-width: 600px)');
const [anchor,setAnchor] = useState('left');
const [drawerOpen, setDrawerOpen] = useState(false);
useEffect(()=>{
  if(application.currentUser && application.currentUser.uid){
    console.info('currentUser',application.currentUser)
    setRole(application.currentUser.role);
    setSignedIn(true);
  }else{
setSignedIn(false);
  }
},[application.currentUser])




  return (
    <>  <Box sx={{ flexGrow: 1 }}>
      <AppBar
        position="sticky"
        color="transparent"
        sx={{
          pt: 1,
          px: { xs: 1, md: 2 },
          bgcolor: 'rgba(58,90,64,0.92)',
          backdropFilter: 'blur(10px)',
          border: '1px solid rgba(247,249,244,0.12)',
        }}
      >
        <Toolbar sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
       
          <ImageButton onClick={()=>navigate('/')} imageSrc={logo} hoverImageSrc={logo} height={isMobile?60:72} width={'auto'} />
          <Typography fontWeight={700} variant={isMobile ? "h6" : "h5"} component="div" sx={{ flexGrow: 1 }}>
            Heart's Ease Cottage
          </Typography>
          <IconButton
            size="large"
            edge="start"
            color="inherit"
            aria-label="menu"
            sx={{ ml: 1, bgcolor: 'rgba(255,255,255,0.12)' }}
            onClick={()=>setDrawerOpen(!drawerOpen)}
          >
            <MenuIcon />
          </IconButton>
         
    
         
        </Toolbar>
      </AppBar>
     
  
    </Box>
    <Drawer 
            anchor={anchor}
            open={drawerOpen}
            onClose={()=>setDrawerOpen(!drawerOpen)}
          >
    <Box
      sx={{
        width: 260,
        height: '100%',
        background: 'linear-gradient(180deg, rgba(159,191,155,0.8) 0%, rgba(58,90,64,0.95) 100%)',
        color: '#F7F9F4'
      }}
      role="presentation"
      onClick={()=>setDrawerOpen(false)}
      
    >
      <Box sx={{
           display: 'flex',
           justifyContent: 'center',
           alignItems: 'center'
        }}>
      <ImageButton onClick={()=>navigate('/')} imageSrc={logo} hoverImageSrc={logo} height={'auto'} width={'100%'} />
      </Box>
      <List>
        {['About','Blog'].map((text, index) => (
          <ListItem key={text} disablePadding>
            <ListItemButton onClick={()=>navigate(text.toLowerCase())}>
              <Typography sx={{ml:3}} color='inherit' fontWeight='bold'>{text}</Typography>
            </ListItemButton>
          </ListItem>
        ))}
         {role==="admin" && 
           <ListItem key="admin" disablePadding>
           <ListItemButton onClick={()=>navigate('/admin')}>
             <Typography sx={{ml:3}} color='inherit' fontWeight='bold'>Admin</Typography>
           </ListItemButton>
         </ListItem>
        }
        {role==="admin" && 
           <ListItem key="key1" disablePadding>
           <ListItemButton onClick={()=>navigate('/manage-posts')}>
             <Typography sx={{ml:3}} color='inherit' fontWeight='bold'>Manage Blog Posts</Typography>
           </ListItemButton>
         </ListItem>
        }
       
{signedIn && 
           <ListItem key="key3" disablePadding>
           <ListItemButton onClick={()=>{
                                      logout();
                                      dispatch(setCurrentUser(null))
                                      setSignedIn(false);
                                      navigate('/');}
                                      
                                      }>
             <Typography sx={{ml:3}} color='text.primary' fontWeight='bold'>Sign Out</Typography>
           </ListItemButton>
         </ListItem>
        }
{!signedIn && 
           <>
           <ListItem key="key4" disablePadding>
           <ListItemButton onClick={()=>navigate('/sign-in')}>
             <Typography sx={{ml:3}} color='inherit' fontWeight='bold'>Sign In</Typography>
           </ListItemButton>
         </ListItem>
           <ListItem key="key5" disablePadding>
           <ListItemButton onClick={()=>navigate('/sign-up')}>
             <Typography sx={{ml:3}} color='inherit' fontWeight='bold'>Create Account</Typography>
           </ListItemButton>
         </ListItem>
         </>
        }
      </List>
      
    </Box>
    </Drawer>
    </>
  
  );
}
